import React, {useContext} from 'react';
import './ConfirmationModal.scss';
import CloseIcon from '@mui/icons-material/Close';
import {I18nContext} from "../../contexts/i18nContext";
import {constructClassNames} from "../../helpers/helpers";
import {Button} from "./index";

const ConfirmationModal = (
  { title, itemName, closeModal, primaryButtonAction, primaryButtonLabel, modalText }
) => {
  const { t } = useContext(I18nContext);
  const contentClasses = [
    {name: 'noTitle', condition: !title},
  ];
  return (
    <div className='confirmationModalBackgroundBlur'>
      <div className='modalBox'>
        <div className='closeButton' onClick={closeModal}>
          <CloseIcon />
        </div>
        {!!title && <div className='modalTitle'>{title}</div>}
        <div className={constructClassNames('modalContent', contentClasses)}>
          {!modalText ? t('are you sure you want to delete') + " " : modalText + " "}
          {itemName}
          ?
        </div>
        <div className='modalButtons'>
          <Button type='secondary' action={closeModal} label={t('cancel')} />
          <Button
            type='primary'
            action={primaryButtonAction}
            label={!primaryButtonLabel ? t('delete') : primaryButtonLabel}
            margin='left'
          />
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
